/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import { Card, Col, Row } from "reactstrap";
import { P } from "../../../AbstractElements";
import CommonUserFooter from "./Common/CommonUserFooter";
import { CommonUserHeader } from "./Common/CommonUserHeader";
import { Gallery, Item } from "react-photoswipe-gallery";
import { Link } from "react-router-dom";
import { dynamicImage } from "../../../Service/DynamicImage";
import { Href } from "../../../Constant";

const SecondData = () => {
  const ProfileData: string = "Success isn't about the end result, it's about what you learn along the way. Confidence. If you have it, you can make anything look good. Grunge is a hippied romantic version of punk. I'm an accomplice to helping women get what they want. Clothes can transform your mood and confidence. I think it's an old fashioned notion that fashion needs to be exclusive to be fashionable.";
  const UserImages: number[] = [1, 2];
  return (
    <Col sm="12">
      <Card>
        <div className="profile-img-style">
          <CommonUserHeader />
          <hr />
          <P>{ProfileData}</P>
          <Row className="mt-3 mb-4 pictures my-gallery">
            <Gallery>
              <Row className="mt-4 pictures my-gallery">
                {UserImages.map((item) => (
                  <figure className="col-sm-6 m-0" key={item}>
                    <Item original={dynamicImage("other-images/profile-style-img3.png")} width="1600" height="600">
                      {({ ref, open }) => (
                        <Link to={Href} onClick={open}>
                          <img className="img-fluid rounded" ref={ref} src={dynamicImage("other-images/profile-style-img.png")} alt="image" />
                        </Link>
                      )}
                    </Item>
                  </figure>
                ))}
              </Row>
            </Gallery>
          </Row>
          <CommonUserFooter />
        </div>
      </Card>
    </Col>
  );
};

export default SecondData;
